<template>
  <div class="md-layout text-center">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-66
        md-medium-size-66
        md-small-size-90
        md-xsmall-size-100
      "
    >
      <auth-card> 
        <md-field class="md-form-group" slot="inputs">
          <md-icon>
            <icon-account/>
          </md-icon>
          <label>Account</label>
          <md-input v-model="account" type=""></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>
            <icon-cdk/>
          </md-icon>
          <label>Password</label>
          <md-input v-model="passwd" type="password"></md-input>
        </md-field>

        <p slot="inputs" style="text-align: left;padding-left: 34px">I agree to allow Amazon Alexa to do the following:</p>
        <p slot="inputs" style="text-align: left;padding-left: 34px">· Obtain information of devices under your account.</p>
        <md-button slot="footer" class="diy-submit md-info md-round" @click="submit">
          Authorization
        </md-button>
      </auth-card>
    </div>
  </div>
</template>
<script>
import { AuthCard } from "@/components";
import { IconCdk, IconAccount } from "@/components/IconSvg";
export default {
  components: {
    AuthCard,
    IconCdk,
    IconAccount,
  },
  created(){
    document.getElementsByTagName("title")[0].text = "Auth login";
  },
  data() {
    return {
      account : "",
      passwd : "",
    };
  },
  methods: {
    submit (){
      if(this.account == ""){
        this.$errorMsg("Account does not exist")
        return 
      }
      if(this.passwd == ""){
        this.$errorMsg("Wrong password")
        return
      }
      var query = {...this.$router.history.current.query}
      this.$api.other_api_authCloud({
        "type": 3,
        "key": query.client_id,
        "client_id": query.scope,
        "client_type": 21,
      })
        .then(this.$Then(res => {
          return this.$api.other_api_authLogin({
            user_id    : this.account,
            ver_type   : 0,
            ver_code   : "",
            area_code  : "",
            user_passwd: this.passwd,
            enc_type   : 2,
            type       : 2,
            auto_signup: 2,
            acc_token  : res.data.token,
          })
        }))
        .then(this.$Then(res => {
          window.location.href = decodeURIComponent(query.redirect_uri) + `?state=${query.state}&code=${res.data.auth_code}`
        }))
        .catch(err => {
          console.error(err)
          if(err.code == 400){
            this.$errorMsg("Parameter error")
          } else if(err.code == 406){
            this.$errorMsg("Account does not exist")
          } else if(err.code == 512){
            this.$errorMsg("Wrong password")
          } else {
            this.$errorMsg("Failed to obtain info.")
          }
        })
    },
  },
};
</script>

<style type="scss" scoped>
  .diy-submit{
    width: 90%;
  }
  .md-form-group{
    margin-top: 30px;
    margin-bottom: 20px;
  }
</style>
